import { render, staticRenderFns } from "./coupon_management.vue?vue&type=template&id=b24f0f88&scoped=true"
import script from "./coupon_management.vue?vue&type=script&lang=js"
export * from "./coupon_management.vue?vue&type=script&lang=js"
import style0 from "./coupon_management.vue?vue&type=style&index=0&id=b24f0f88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f0f88",
  null
  
)

export default component.exports